<template>
  <el-dialog title="选择显示字段" round :visible.sync="dialogVisible" width="700px">
    <el-tree :data="allList" @check="check" default-expand-all node-key="id" :default-checked-keys="checkedList" show-checkbox>
    </el-tree>

    <div slot="footer" class="dialog-footer">
      <el-button type="default" plain @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>

export default {
  props: {
    allTemplate: {
      tyep: Array
    },
    cList: {
      type: Array
    }
  },
  data() {
    return {
      dialogVisible: false,
      checkedList: [],
      allList: []
    }
  },
  created() {
  },
  methods: {
    open() {
      let list = this.allTemplate.map(i => ({ id: i.prop, label: i.label }))
      this.allList = [{ id: '', label: '全部', children: list }]
      this.checkedList = this.cList.map(i => i.prop)
      this.dialogVisible = true;
    },
    check(currentObj, treeStatus) {
      this.checkedList = treeStatus.checkedKeys;
    },
    submit() {
      if (this.checkedList[0] == '' && this.checkedList.length) {
        this.checkedList.shift()
      }
      this.$emit("updated", this.checkedList);
      this.dialogVisible = false;
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  .el-dialog__title {
    font-size: 20px;
  }
}
.el-form {
  ::v-deep .el-form-item__label {
    font-weight: 400;
  }
  .el-input {
    width: 336px;
  }
}

.distpicker-address-wrapper {
  ::v-deep select {
    width: 110px;
  }
}
</style>
